import { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'
import { ReactComponent as ActivitiesIcon } from 'assets/images/icons/activities.svg'
import { ReactComponent as NotificationIcon } from 'assets/images/icons/notification.svg'
import { ReactComponent as ExpanderOnIcon } from 'assets/images/icons/expander_on.svg'
import { ReactComponent as SettingIcon } from 'assets/images/icons/settings.svg'
import { ReactComponent as LogoutIcon } from 'assets/images/icons/logout.svg'
import { ReactComponent as LifeIcon } from 'assets/images/icons/life.svg'
import { ReactComponent as MenuIcon } from 'assets/images/icons/menu.svg'
import { ReactComponent as InviteUserIcon } from 'assets/images/icons/Add_users-l.svg'
import { ReactComponent as FilterIcon } from 'assets/images/icons/filter.svg'
import { ReactComponent as SearchIcon } from 'assets/images/icons/search24.svg'
import { ReactComponent as ExternalLink } from 'assets/images/icons/external-link.svg'
import { HiOutlineViewGridAdd } from 'react-icons/hi'
import { GlobalSearchButton, MoreButton, NotificationDropdown, ProfileInfo, ToolBar } from './../styles'
import Avatar from 'modules/auth/components/Avatar'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledTooltip } from 'reactstrap'
import { CustomButton } from 'modules/auth/styles'
import { NotificationItem } from './NotificationItem'
import { ProductUpdates } from './ProductUpdates'
import { BsChatDots, BsCheckAll, BsGear } from 'react-icons/bs'
import {
  getCompany_action,
  getNotifications_action,
  setMarkAllAsReadOnClick_action,
  setMarkAsReadOnClick_action,
  toggleGlobalSearchModal_action,
  toggleInviteTeammates_action,
  logout_action,
  changeTab_action,
  toggleSettingsModal_action
} from 'store/actions'
import { MemberTabs } from 'modules/company/styles'
import { markAsReadNotification_api } from 'store/apis'
import { handleApiError, handleExternalLink, handleNotificationScroll, isZoom, openUrlFromZoom, sliceText } from 'utils/helpers'
import { PageLoader } from 'utils/storageUtils'
import { useLocation } from 'react-router-dom'

const usePrevious = (value) => {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  }, [value])
  return ref.current
}

var _activeTab = 'mention'

export const ToolbarNav = (props) => {
  const { user, notifications, getNotifications, setMarkAsReadOnClick, setMarkAllAsReadOnClick, getCompany, fullScreenStatus } = props

  const { pathname } = useLocation()

  // Toggle Settings dropdown
  const [ShowNotificationDD, set_ShowNotificationDD] = useState(false)
  const [showSettingsMenu, set_showSettingsMenu] = useState(false)
  const [showProductUpdate, set_showProductUpdate] = useState(false)
  const [notifications_state, set_notifications_state] = useState({ ...notifications.mention })
  const [activeTab, set_activeTab] = useState('mention')
  const [notification_loading, set_notification_loading] = useState(false)
  const [changeScreen_loading, set_changeScreen_loading] = useState(false)
  const prevActiveTab = usePrevious(activeTab)

  const handleClickOutside = () => {
    set_showSettingsMenu(false)
  }
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    return () => document.removeEventListener('click', handleClickOutside, true)
  }, [])

  // set page title, close settings
  const prevPath = usePrevious(pathname)
  useEffect(() => {
    if (prevPath !== pathname) {
      set_showSettingsMenu(false)
    }
  }, [pathname, prevPath])

  const pwaIntall = () => {
    if (window.deferredPrompt) {
      window.deferredPrompt.prompt()
    }
  }

  // Mark As Read
  const onMarkAsReadAll = () => {
    setMarkAllAsReadOnClick()
    markAsReadNotification_api('all')
    getCompany()
  }
  const onMarkAsRead = (notiUser_id) => {
    set_ShowNotificationDD(false)
    setMarkAsReadOnClick(notiUser_id)
    markAsReadNotification_api(notiUser_id)
    getCompany()
  }
  useEffect(() => {
    set_notifications_state({ ...notifications[activeTab] })
    _activeTab = activeTab
  }, [activeTab, notifications])
  const switchTab = (e) => {
    e.preventDefault()
    set_activeTab(e.target.attributes['id'].value)
  }
  useEffect(() => {
    if (!isZoom()) {
      document.body.style.removeProperty('overflow-y')
      document.querySelector('.notification-items').removeEventListener('scroll', (e) => {
        handleNotificationScroll(e, _activeTab, getNotifications, set_notification_loading)
      })
      if (ShowNotificationDD) {
        document.body.style.overflowY = 'hidden'
        document.querySelector('.notification-items').addEventListener('scroll', (e) => {
          handleNotificationScroll(e, _activeTab, getNotifications, set_notification_loading)
        })
        set_notification_loading(false)
      }
    }
  }, [ShowNotificationDD, getNotifications, activeTab])

  useEffect(() => {
    const getNotification = async () => {
      if (prevActiveTab && prevActiveTab !== activeTab) {
        try {
          set_changeScreen_loading(true)
          await getNotifications({ type: activeTab })
        } catch (e) {
          handleApiError(e)
        }
        set_changeScreen_loading(false)
      }
    }
    getNotification()
  }, [activeTab, prevActiveTab, getNotifications])

  const toggleNotification = async () => {
    set_ShowNotificationDD((value) => !value)
    if (!ShowNotificationDD) {
      try {
        set_changeScreen_loading(true)
        await getNotifications({ type: activeTab ? activeTab : 'mention' })
      } catch (e) {
        handleApiError(e)
      }
      set_changeScreen_loading(false)
    }
  }
  return (
    <ToolBar>
      {!fullScreenStatus && (<li onClick={() => props.toggleGlobalSearchModal(true)}>
        <GlobalSearchButton>
          <SearchIcon />
          <span className='d-none d-sm-inline'>Search all files</span>
        </GlobalSearchButton>
      </li>)}

      {!isZoom() && user.membership && user.membership.user_type === 'admin' && (
        <li>
          <GlobalSearchButton onClick={(e) => props.toggleInviteTeammates(true)}>
            <InviteUserIcon />
            <span className='ml-1 d-none d-sm-inline'>Invite Teammates</span>
          </GlobalSearchButton>
        </li>
      )}
      {(process.env.REACT_APP_NODE_ENV === 'development' ||
        (props.is_subscription_loaded && !props.isOnGracePeriod && !props.is_subscribed && props.user.membership && props.user.membership.user_type === 'admin')) && (
          !fullScreenStatus && (<li>
            <CustomButton
              className='light-blue-100 btn-sm shadow-none '
              onClick={() => {
                if (!isZoom()) {
                  props.changeTab('billing')
                  props.toggleSettingsModal(true)
                } else {
                  openUrlFromZoom(`${process.env.REACT_APP_BASE_URL}?open=settings&tab=billing`)
                }
              }}>
              Upgrade Plan
            </CustomButton>
          </li>)
        )}
      {/* Notifications */}
      {!isZoom() && (
        <li>
          <NotificationDropdown isfullscreen={fullScreenStatus?.toString()} isOpen={ShowNotificationDD} toggle={toggleNotification}>
            <DropdownToggle className='btn-toggle'>
              <ActivitiesIcon id='notification' />
              {notifications.unreadNotificationsCount > 0 && <span className='new-mark'></span>}
            </DropdownToggle>
            <DropdownMenu right className='shadow py-0'>
              <div className='dropdown-header'>
                <div className='d-flex justify-content-between align-items-center'>
                  <span className='title'>Notifications</span>
                  <MoreButton className='more-button-dropdown'>
                    <DropdownToggle caret={false} tag='div'>
                      <CustomButton type='button' className='toggle shadow-none gray'>
                        <MenuIcon />
                      </CustomButton>
                    </DropdownToggle>
                    <DropdownMenu right className='sub-menu shadow'>
                      <DropdownItem className='border-bottom' onClick={() => onMarkAsReadAll()}>
                        <BsCheckAll />
                        Mark All As Read
                      </DropdownItem>
                      <DropdownItem
                        className='border-bottom'
                        onClick={() => {
                          props.toggleSettingsModal(true)
                          props.changeTab('notifications')
                        }}>
                        <BsGear />
                        Notification Settings
                      </DropdownItem>
                    </DropdownMenu>
                  </MoreButton>
                </div>
                <MemberTabs className='mb-0 mt-4'>
                  <a href='/' onClick={switchTab} id='mention' className={`${activeTab === 'mention' ? 'active' : ''}`}>
                    Mentions
                  </a>
                  <a href='/' onClick={switchTab} id='activity' className={`${activeTab === 'activity' ? 'active' : ''}`}>
                    Activities
                  </a>
                </MemberTabs>
              </div>

              <div className='notification-items'>
                {!changeScreen_loading && notifications_state.data && Array.isArray(notifications_state.data) && notifications_state.data.length === 0 && (
                  <div className='d-flex flex-column justify-content-cneter align-items-center p-4'>
                    <div className='rounded-circle bg-light p-3 mb-3'>
                      <NotificationIcon style={{ width: 40, height: 40 }} />
                    </div>
                    <div className='text-muted'>No recent notification</div>
                  </div>
                )}
                {changeScreen_loading && <PageLoader />}
                {!changeScreen_loading && notifications_state.data && Array.isArray(notifications_state.data) && (
                  <>
                    {notifications_state.data.map((noti, i) => (
                      <div key={noti.id} className='notification'>
                        <NotificationItem noti={noti} onMarkAsRead={onMarkAsRead} />
                      </div>
                    ))}
                    {notification_loading && notifications_state.data.length !== 0 && <PageLoader />}
                  </>
                )}
              </div>
            </DropdownMenu>
          </NotificationDropdown>
          <UncontrolledTooltip target='notification'>Notifications</UncontrolledTooltip>
        </li>
      )}

      {/* Help */}
      {!fullScreenStatus && (<li className={`has-menu ${showSettingsMenu === 'help' ? 'clicked' : 'hideDropDown'}`} onClick={() => set_showSettingsMenu((value) => (value === 'help' ? false : 'help'))}>
        <ProfileInfo>
          <LifeIcon id='help' />
          <UncontrolledTooltip target='help'>Help</UncontrolledTooltip>
        </ProfileInfo>
        <nav>
          <ul>
            <li onClick={() => setTimeout(() => set_showSettingsMenu(false), 100)} className='p-0'>
              <a href='https://help.klutch.app/en/' target='_blank' rel='noreferrer' className='text-black p-3 w-100' onClick={handleExternalLink}>
                <ExternalLink />
                Help center
              </a>
            </li>
            {!isZoom() && (
              <>
                <hr className='menuSeparater' />
                <li
                  onClick={() => {
                    setTimeout(() => set_showSettingsMenu(false), 100)
                    window.$chatway.openChatwayWidget();
                  }}>
                  <BsChatDots />
                  Chat with us
                </li>
              </>
            )}
          </ul>
        </nav>
      </li>)}

      {/* Settings */}
      <li
        className={`has-menu ${showSettingsMenu === 'settings' ? 'clicked' : 'hideDropDown'}`}
        onClick={() => {
          if (showProductUpdate) {
            set_showProductUpdate(false)
          }
          set_showSettingsMenu((value) => (value === 'settings' ? false : 'settings'))
        }}>
        <ProfileInfo>
          <Avatar user={user} color='main-blue' />
          <div className='ml-2 text-capitalize d-none d-sm-block'>
            {sliceText(user.name, 13)}
            <ExpanderOnIcon />
          </div>
        </ProfileInfo>
        <nav style={{zIndex: fullScreenStatus ? '30000000000' : '10'}} className={showProductUpdate ? 'product-updates' : ''}>
          {!showProductUpdate && (
            <ul>
              {!isZoom() && (
                <>
                  <li
                    onClick={() => {
                      setTimeout(() => set_showSettingsMenu(false), 100)
                      props.toggleSettingsModal(true)
                    }}>
                    <SettingIcon />
                    Manage Account
                  </li>
                  <hr className='menuSeparater' />
                </>
              )}
              <li onClick={() => set_showProductUpdate(true)}>
                <FilterIcon />
                Product Updates
              </li>
              <hr className='menuSeparater' />
              {window.innerWidth <= 576 && (
                <li onClick={() => pwaIntall()}>
                  <HiOutlineViewGridAdd />
                  Add to home
                </li>
              )}
              <li onClick={() => props.onLogout()}>
                <LogoutIcon />
                Logout
              </li>
            </ul>
          )}
          {showProductUpdate && <ProductUpdates {...props} set_showProductUpdate={set_showProductUpdate} />}
        </nav>
      </li>
    </ToolBar>
  )
}

const mapStateToProps = (state) => ({
  changelog: state.app.changelog,
  isMainMenuOpen: state.app.isMainMenuOpen,
  user: state.auth.user,
  is_subscribed: state.subscription.is_subscribed,
  is_subscription_loaded: state.subscription.is_subscription_loaded,
  notifications: state.company.notifications,
  location: state.router,
  fullScreenStatus: state.contents.isFullScreen
})

const mapDispatchToProps = (dispatch) => ({
  onLogout: () => dispatch(logout_action()),
  toggleSettingsModal: (status) => dispatch(toggleSettingsModal_action(status)),
  changeTab: (value) => dispatch(changeTab_action(value)),
  getCompany: () => dispatch(getCompany_action()),
  getNotifications: (filters) => new Promise((resolve, reject) => dispatch(getNotifications_action(filters, resolve, reject))),
  toggleInviteTeammates: (status) => dispatch(toggleInviteTeammates_action(status)),
  setMarkAsReadOnClick: (notiUser_id) => dispatch(setMarkAsReadOnClick_action(notiUser_id)),
  setMarkAllAsReadOnClick: () => dispatch(setMarkAllAsReadOnClick_action()),
  toggleGlobalSearchModal: (status) => dispatch(toggleGlobalSearchModal_action(status))
})

export default connect(mapStateToProps, mapDispatchToProps)(ToolbarNav)
